import React from 'react';
import { Select } from 'antd';

interface SelectOption {
  label: string;
  value: any;
}

interface SelectFieldProps {
  mode?: 'multiple' | 'tags';
  placeholder?: string;
  value?: any;
  onChange?: (value: any) => void;
  options?: SelectOption[];
  searchable?: boolean;
  status?: 'error' | 'warning';
  [key: string]: any;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  mode,
  placeholder,
  value,
  onChange,
  options = [],
  searchable = true,
  status,
  ...props
}) => {

  // Handle value transformation for tags mode
  let processedValue = value;
  if (mode === 'tags' && typeof value === 'string' && value.trim()) {
    // If value is a string but mode is tags, split it into array
    processedValue = value.split(',').filter(Boolean).map(item => item.trim());
  } else if (mode === 'tags' && !Array.isArray(value)) {
    // If mode is tags but value is not an array, default to empty array
    processedValue = [];
  }

  return (
    <Select
      mode={mode}
      placeholder={placeholder}
      allowClear
      showSearch={searchable}
      filterOption={
        searchable
          ? (input, option) =>
              String(option?.children ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
          : undefined
      }
      value={processedValue || (mode === 'multiple' || mode === 'tags' ? [] : undefined)}
      onChange={onChange}
      status={status}
      {...props}
    >
      {options.map(option => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};
